<template>
  <div>
    <el-table
      :data="previewOrderedDetails"
      border
      style="width: 100%"
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-colorpd"
    >
      <!-- <el-table-column prop="Ids" label="IDS" min-width="50px">
      </el-table-column> -->
      <el-table-column label="Image" min-width="200px">
        <template v-slot="{ row }">
          <img
            :src="imageURL + row.attributeImageId.productImage[0]"
            alt="image"
            class="productmenu-tbl"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="productDetails"
        label="Product Details"
        min-width="160px"
      >
        <template v-slot="{ row }">
          <div>
            <h4 class="font-semibold fsize14 mb-2">{{ row.productName }}</h4>

            <p class="font-semibold fsize12">
              {{ row.attribute }}-<span class="font-normal">{{
                row.attributeVal
              }}</span>
            </p>

            <p class="font-semibold fsize12">
              {{ row.variation }}-<span class="font-normal">{{
                row.variationVal
              }}</span>
            </p>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="price" label="Price" min-width="150px">
        <template v-slot="{ row }">
          <P class="text-gray">{{ row.actualPrice }}</P>
        </template>
      </el-table-column>
      <el-table-column prop="quality" label="Quantity" min-width="100px">
        <template v-slot="{ row }">
          <P class="text-gray">{{ row.quantity }}</P>
        </template> </el-table-column
      ><el-table-column prop="salePrice" label="Sale Price" min-width="100px">
        <template v-slot="{ row }">
          <P class="text-gray">{{ row.discountedPrice }}</P>
        </template>
      </el-table-column>
    </el-table>

    <div class="mt-6 bg-f4f5f6 py-4 px-6" v-if="orderData.cancelledReason">
      <h4 class="fsize14 font-semibold">Cancelled Reason</h4>

      <h4 class="fsize14 font-medium">{{ orderData.cancelledReason }}</h4>
    </div>
    <div class="mt-6 flex justify-between bg-f4f5f6 py-4 px-6">
      <h4 class="fsize14 font-semibold">Total Price</h4>

      <h4 class="fsize14 font-medium">{{ totalPrice }}</h4>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    previewOrderedDetails: {
      Type: Object,
    },
    orderData: {
      Type: Object,
    },
  },
  data() {
    return {
      tableData: [
        {
          Ids: "01",
          quality: "2",
          price: "₹2000",
          salePrice: "₹1000",
        },
      ],
    };
  },
  computed: {
    imageURL() {
      // console.log(this.$imageURL);
      return `${this.$imageURL}/`;
    },
    totalPrice() {
      let totalPrice = 0;
      for (let i = 0; i < this.previewOrderedDetails.length; i++) {
        totalPrice =
          totalPrice +
          parseFloat(this.previewOrderedDetails[i].discountedPrice);
      }
      return totalPrice;
    },
  },
};
</script>
